module.exports = __webpack_public_path__ + "img/bank-blue-two.af97dac2.png";